<template>
    <div class="resource">
        <header>
            <Header />
        </header>
        <div class="resource-content-box">
            <div class="content-box-data">
                <div class="resource-box">
                    <div class="resource-box-title">个人中心</div>
                    <div class="resource-box-desc">管理您的账户信息和资源发布信息</div>
                </div>
                <el-card class="box-card" >
                    <el-tabs tab-position="left" type="card" v-model="activeName">
                        <el-tab-pane label="账号信息" name="first">
                            <UserTable />
                        </el-tab-pane>
                        <el-tab-pane label="资源发布" name="second">
                            <ReleaseTable />
                        </el-tab-pane>
                        <!-- <el-tab-pane label="收益统计管理">
                            <IncomeTable />
                        </el-tab-pane>
                        <el-tab-pane label="收益分析管理">
                            <AnalysisTable />
                        </el-tab-pane> -->
                        <el-tab-pane label="资源订单" name="third">
                            <PayTable />
                        </el-tab-pane>
                    </el-tabs>
                </el-card>
            </div>
        </div>
        
    </div>
</template>

<script>
import Header from '../../components/header.vue';
import UserTable from './userAccount.vue'
import ReleaseTable from './Resource/release.vue';
// import IncomeTable from './Resource/income.vue';
// import AnalysisTable from './Resource/analysis.vue';
import PayTable from './Demand/pay.vue';
export default {
    // name:'个人中心-需求用户',
    components: {
		Header,
        UserTable,
        ReleaseTable,
        // IncomeTable,
        // AnalysisTable,
        PayTable,
	},
    data() {
        return {
            // activeName:'first',
            // 从sessionStorage中获取activeName 
            activeName:sessionStorage.getItem('activeName') || 'first',
        };
    },

    mounted() {
        // 从sessionStorage中获取activeName
        // this.activeName = sessionStorage.getItem('activeName') || 'first';
        // 监听路由变化
        // this.$router.afterEach((to, from) => {
        //     // 从路由参数中获取activeName
        //     if (to.query.activeName) {
        //         this.activeName = to.query.activeName;
        //     }
        // });
    },

    methods: {
        
    },
};
</script>
<style lang="scss" scoped>
.resource-content-box{
    width: 100%;
	height:auto;
    min-height:calc(100vh - 140px);
	padding:30px 0 20px;
	background-color: #f9fafb;
    .content-box-data{
        width:80%;
        height:auto;
        margin:0 auto;
        // background-color:#fff;
        .resource-box{
            width:100%;
            height:auto;
            margin-bottom:20px;
            box-sizing: border-box;
            padding:20px 20px;
            border-radius:5px;
            box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
            background-color:#fff;
            .resource-box-title{
                font-size:1.25rem;
                font-weight:600;
                color:#000;
            }
            .resource-box-desc{
                font-size:0.8rem;
                color:#666;
                margin-top:10px;
            }
        }
        // .box-card-title{
        //     width: 100%;
        //     font-size:0.8rem;
        //     font-weight:600;
        //     text-align: center;
        //     margin-bottom:20px;
        // }
        // .resource-form{
        //     width:500px;
        //     height:auto;
        //     margin:0 auto;
        // }
    }
}
</style>